// Darty SSO session is valid for the current day, on next day at 00:00:00, the session will expire and user need to login again if they want to access Darty portal.
export const getDartyExpiration = (): Date => {
    const now = new Date()
    // Set to end of the current day (23:59:59.999)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999)

    return endOfDay
}
